function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M29.5186 64.0175H6.20549L3.79309 29.6602H31.929L29.5186 64.0175Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M33.9999 27.3281C33.9999 27.7937 33.5732 28.1745 33.0511 28.1745H1.74744C1.22567 28.1745 0.79895 27.8315 0.79895 27.4118C0.79895 26.9921 1.20626 26.5215 1.70427 26.3656L3.24047 25.885C3.73848 25.729 4.14579 25.1748 4.14579 24.653V23.9776C4.14579 23.4558 4.57251 23.0291 5.09429 23.0291H29.7043C30.2264 23.0291 30.6531 23.4558 30.6531 23.9776V24.653C30.6531 25.1748 31.0658 25.7103 31.5705 25.8428L33.0826 26.2404C33.5869 26.3733 33.9999 26.8629 33.9999 27.3281Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.09506 0.864968C6.31622 2.99122 5.06048 6.21021 6.25965 8.89772C7.30487 11.2405 10.1259 12.2703 9.62055 15.1995C9.38192 16.5837 8.47694 17.4673 7.9381 18.6765C7.41565 19.8486 9.14564 20.871 9.67209 19.6899C10.1226 18.6792 10.8472 17.8167 11.2622 16.7584C11.9372 15.0382 11.8091 13.1921 10.9556 11.5708C10.4452 10.6006 9.51078 9.95532 8.77012 9.18321C7.86681 8.24174 7.67336 6.88493 7.89626 5.65329C8.10912 4.47521 8.82568 3.10869 9.51479 2.2847C10.3398 1.29872 8.92709 -0.129713 8.09506 0.864968Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15.8356 0.864968C14.0571 2.99122 12.8013 6.21021 14.0002 8.89772C15.0451 11.2405 17.8658 12.2703 17.3607 15.1995C17.1221 16.5837 16.2171 17.4673 15.6786 18.6765C15.1565 19.8486 16.8865 20.871 17.4126 19.6899C17.8631 18.6792 18.5874 17.8164 19.0024 16.7584C19.6771 15.0382 19.5492 13.1921 18.6961 11.5708C18.1857 10.6006 17.2516 9.95532 16.511 9.18321C15.6077 8.24174 15.4146 6.88493 15.6371 5.65329C15.85 4.47521 16.5665 3.10869 17.2556 2.2847C18.08 1.29872 16.6673 -0.129713 15.8356 0.864968Z",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M23.5036 0.864969C21.7248 2.99122 20.4691 6.21021 21.6682 8.89772C22.7131 11.2405 25.5345 12.2703 25.0291 15.1995C24.7905 16.5837 23.8855 17.4673 23.3467 18.6765C22.8242 19.8486 24.5542 20.871 25.081 19.6899C25.5315 18.6792 26.2561 17.8167 26.6711 16.7584C27.3461 15.0382 27.218 13.1921 26.3648 11.5708C25.8541 10.6006 24.92 9.95532 24.179 9.18321C23.2757 8.24174 23.0826 6.88493 23.3052 5.65329C23.5184 4.47487 24.2346 3.10869 24.924 2.2847C25.7484 1.29905 24.3353 -0.129378 23.5036 0.864969Z",
  fill: "black"
});

function SvgDecaf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 65,
    viewBox: "0 0 34 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecaf);
export default __webpack_public_path__ + "static/media/decaf.48288e70.svg";
export { ForwardRef as ReactComponent };